import { createAsyncThunk } from '@reduxjs/toolkit';
import { discussionApi } from '~/apis/discussion';
import {
  CREATE_ENTRY,
  CREATE_REPLY,
  DELETE_ENTRY,
  GET_DETAIL_DISCUSSION,
  GET_DISCUSSION_ENTRIES,
  GET_FULL_DISCUSSION_ENTRIES,
  MARK_READ_ALL_ENTRIES,
  UPDATE_ENTRY,
} from '~/utils/constants/actionType';
import {
  IBodyMarkReadAllEntries,
  IBodyUpdateEntry,
  IQueryDeleteEntry,
  IQueryGetDiscussionDetail,
  IQueryGetDiscussionEntries,
  IQueryGetFullDiscussionEntries,
} from '~/utils/interface/discussion';

export const getDetailDiscussion = createAsyncThunk(
  GET_DETAIL_DISCUSSION,
  async (query: IQueryGetDiscussionDetail, { rejectWithValue }) => {
    try {
      const res = await discussionApi.getDetailDiscussion(query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDiscussionEntries = createAsyncThunk(
  GET_DISCUSSION_ENTRIES,
  async (query: IQueryGetDiscussionEntries, { rejectWithValue }) => {
    try {
      const res = await discussionApi.getDiscussionEntries(query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getFullDiscussionEntries = createAsyncThunk(
  GET_FULL_DISCUSSION_ENTRIES,
  async (query: IQueryGetFullDiscussionEntries, { rejectWithValue }) => {
    try {
      const res = await discussionApi.getFullDiscussionEntries(query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createEntry = createAsyncThunk(CREATE_ENTRY, async (body: FormData, { rejectWithValue }) => {
  try {
    const res = await discussionApi.createEntry(body);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateEntry = createAsyncThunk(UPDATE_ENTRY, async (body: IBodyUpdateEntry, { rejectWithValue }) => {
  try {
    const res = await discussionApi.updateEntry(body);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createReply = createAsyncThunk(CREATE_REPLY, async (body: FormData, { rejectWithValue }) => {
  try {
    const res = await discussionApi.createReply(body);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteEntry = createAsyncThunk(DELETE_ENTRY, async (params: IQueryDeleteEntry, { rejectWithValue }) => {
  try {
    const res = await discussionApi.deleteEntry(params);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const markReadAllEntries = createAsyncThunk(
  MARK_READ_ALL_ENTRIES,
  async (body: IBodyMarkReadAllEntries, { rejectWithValue }) => {
    try {
      const res = await discussionApi.markReadAllEntries(body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
